'use client';
import { Player as DefaultPlayer } from '@u-next/defaultplayer';
import Link from 'next/link';
import { appPublicConfig } from '@/configs/appPublicConfig';
import { Loading } from '@/shared/components/parts/Loading';
import { MainContainer } from '@/shared/components/parts/MainContainer';
import { Spacer } from '@/shared/components/parts/Spacer';
import { usePretestPlayBack } from './index.hook';

export const PretestPlayBack: React.FC = () => {
  const { state, handleOnPlayerError } = usePretestPlayBack();

  return (
    <MainContainer>
      <Spacer level={3} />
      <div className="tw-text-h2 tw-text-main-100">視聴環境の動作確認</div>
      <Spacer level={2} />
      <div>
        テスト動画を再生して、お客様の視聴環境を確認してください。
        <br />
        <Link
          href={`${appPublicConfig.HELP}/guide/browse/category5`}
          target="_blank"
          rel="noopener noreferrer"
          className="tw-underline"
        >
          対応デバイス
        </Link>
      </div>
      <Spacer level={2} />
      {state.pageStatus === 'INIT' && <Loading />}
      {state.pageStatus === 'PLAY' && state.playerProps && (
        <div className="tw-aspect-video tw-bg-main-100">
          <DefaultPlayer {...state.playerProps} onError={handleOnPlayerError} />
        </div>
      )}
      {state.pageStatus === 'ERROR' && (
        <div className="tw-rounded-4 tw-bg-caution-lv1 tw-p-[1rem] tw-text-base-lv1">
          <div className="tw-text-h4">再生に失敗しました</div>
          <Spacer level={1} />
          <div>{state.errorMessage.title}</div>
          <div>{state.errorMessage.text}</div>
          <div>errorCode: {state.errorMessage.errorCode}</div>
        </div>
      )}
      <Spacer level={4} />
    </MainContainer>
  );
};
